import { configureStore } from '@reduxjs/toolkit';
import CustomizerReducer from './customizer/CustomizerSlice';
import AuthReducer from './auth/AuthSlice';
import UserProfileReducer from './user/UserSlice';
import IndustryReducer from './industry/IndustrySlice';
import UtilReducer from './util/UtilSlice';
import CallCenterReducer from './callcenter/CallCenterSlice';
import SupplierReducer from './supplier/SupplierSlice';
import FileReducer from './file/FileSlice';
import SupplierAppReducer from './supplierApp/supplierAppSlice';
import SupplierFileReducer from './file/SupplierFileSlice';
import notificationReducer from './notification/NotificationSlice';

export const store = configureStore({
  reducer: {
    customizer: CustomizerReducer,
    auth: AuthReducer,
    userDetail: UserProfileReducer,
    industry: IndustryReducer,
    util: UtilReducer,
    callCenter: CallCenterReducer,
    supplier: SupplierReducer,
    file: FileReducer,
    supplierApp: SupplierAppReducer,
    supplierFile: SupplierFileReducer,
    notification: notificationReducer 
  },
});

export default store;
